import React, { useContext, useEffect, useRef, useState } from 'react'
import './Khadyaadvreport.css'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import info from "../../imgs/info.png";
import back from "../../imgs/backexam.png";
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Language, YoutubeSearchedForOutlined } from '@material-ui/icons';
import khadya from "../../imgs/khadya.png";
import cash from "../../imgs/cash.png";
import { UilEditAlt, UilEye, UilSetting } from '@iconscout/react-unicons'
import { useTranslation } from "react-i18next";
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";

const Khadyaadvreport = (props) => {
    const { t, i18n } = useTranslation();

    const [input, setInput] = useState({ date1: new Date().toISOString().substr(0, 10), date2: new Date().toISOString().substr(0, 10), kno: "", kname: "", lastkhadya: "", lastadv: "", lastdate: "", dno: "", name: "", khname: "", searchsank: "", khname: "", purdate: "" });
    const inputRefs = useRef([]);
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [DataSourcekh, setDataSourcekh] = useState([]);
    const [DataSourceadv, setDataSourceadv] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [print, setprint] = useState(false);
    const cellRefs = useRef([]);
    const [value, setValue] = useState('');
    const [partyData, setPartydata] = useState([]);
    const [PreviousAmt, setPreviousAmt] = useState();
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [customerData, setCustomerData] = useState([]);
    const [khrtype, setKhrtype] = useState("khpur");
    const navigate = useNavigate();
    const refprint = useRef(null);
    const refsaledetails = useRef(null);
    const refsaledetailsclose = useRef(null);
    const [khnames, setKhnames] = useState([]);
    const [khsaledetails, setKhsaledetails] = useState([]);
    const refprintclose = useRef(null);
    const [mobileusers, setMobileusers] = useState([]);
    const [wait, setWait] = useState(false);

    const handlertype = (type) => {
        setKhrtype(type)
    }

    useEffect(() => {
        setDataSource([]);
    }, [khrtype])

    const handleprintclose = () => {
        refprintclose.current.click();
    }

    const handledetails = (khname, purdate) => {

        setInput(prevInput => ({
            ...prevInput,
            khname: khname,
            purdate: purdate,
        }));
    }


    useEffect(() => {
        if (input.khname !== "") {
            getkhsaledetails(input.khname, input.purdate);
        }
    }, [input.khname])

    useEffect(() => {
        if (input.purdate !== "") {
            getkhsaledetails(input.khname, input.purdate);
        }
    }, [input.purdate])

    const handledetailsclose = () => {
        refsaledetailsclose.current.click();
    }


    async function getkhsaledetails(khname, purdate) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhsaledetailsperti.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2, khname: khname, purdate: purdate }).then(function sample(response) {

            if (response.data) {
                setKhsaledetails(response.data);
                refsaledetails.current.click();
            }

        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKey(event, currentIndex) {

        if (event.keyCode === 8) {
            if (event.target.name === "time") {
                setInput((prevInputSettings) => ({
                    ...prevInputSettings,
                    time: '',
                }));
            }
            else if (event.target.name === "type") {
                setInput((prevInputSettings) => ({
                    ...prevInputSettings,
                    type: '',
                }));
            }
        }

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            if (currentIndex === 2) {
                if (input.name !== "") {
                    nextIndex = currentIndex + 1;
                }
                else {
                    nextIndex = currentIndex;
                }
            }
            else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
    }

    const filteData = (e) => {
        const searchValue = e.target.value.trim();

        if (searchValue !== "") {
            setValue(searchValue);
            const filtertable = DataSource.filter(o =>
                String(o.kno) === searchValue // Check for exact match with kno
            );

            setTableFilter([...filtertable]);
        } else {
            setValue(searchValue);
            setTableFilter([...DataSource]);
        }

    };

    const filteDataold = (e) => {
        if (e.target.value != "") {
            setValue(e.target.value);
            const filtertable = DataSource.filter(o => Object.keys(o).some(k =>
                String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
            ));

            setTableFilter([...filtertable]);
        }
        else {
            setValue(e.target.value);
            setTableFilter([...DataSource]);
        }
    }
    const showprint = () => {
        if (DataSource && DataSource.length > 0) {
            localStorage.setItem("date1print", input.date1);
            localStorage.setItem("date2print", input.date2);
            if (khrtype === "dreport") {
                localStorage.setItem("kno", input.dno);
            }
            else {
                localStorage.setItem("kno", value);
            }
            localStorage.setItem("partyname", input.name);
            localStorage.setItem("khrtype", khrtype);
            localStorage.setItem("khname", input.khname);
            const url = "/khadyaadvreportprint";
            window.open(url, '_blank');
        }
        else {
          notifyerror(t("Khadyaadvreport.toast.noDataForPeriod"));
        }
    }

    async function getkhname() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhname.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {

                setKhnames(response.data);
            }

        }).catch(err => {
            console.log(err);
        });
    }


    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));

        if (name === 'date2') {
            // Check if date2 is more than one year ahead of date1
            const date1 = new Date(input.date1);
            const date2 = new Date(valuecurrent);

            // Calculate the difference in days between date1 and date2
            const differenceInDays = (date2 - date1) / (1000 * 60 * 60 * 24);

            // setInput((prevInput) => ({ ...prevInput, [name]: valuecurrent }));
            if (differenceInDays <= 30) {
                setInput((prevInput) => ({ ...prevInput, [name]: valuecurrent }));
            } else {
              notifyerror(t("Khadyaadvreport.toast.reportLimitOneMonth"));
                setInput((prevInput) => ({ ...prevInput, [name]: new Date().toISOString().substr(0, 10) }));
            }
        }
    }

    const getkhpurreport = () => {
        setValue("");
        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "";
        // console.log(khrtype);
        if (khrtype === "khpur") {
            landingphp = "getkhpurreport.php";
        }
        else if (khrtype === "khsale") {
            landingphp = "getkhsalereport.php";
        }
        else if (khrtype === "adv") {
            landingphp = "getadvreport.php";
        }
        else if (khrtype === "udhari") {
            landingphp = localStorage.getItem("bill10type") === "1" ? "getudhari4.php" : localStorage.getItem("bill10type") === "0" ? "getudhari5.php" : ''
        }
        else if (khrtype === "thakbaki") {
            landingphp = "getthakbaki2.php"
        }
        else if (khrtype === "stock") {
            notify(localStorage.getItem("khdate"));
            if (localStorage.getItem("khdate") === "no") {
                landingphp = "getkhstock.php";
            }
            else {
                landingphp = "getkhdatewisestock.php"
            }
        }
        else if (khrtype === "datestock") {
            landingphp = "getkhstockbydate.php";
        }
        else if (khrtype === "dreport") {
            landingphp = "getkhpartystatement2.php";
        }
        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: khrtype === "dreport" ? input.dno : value,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            purdate: localStorage.getItem("purdate"),
            khname: input.khname,
            billtype: localStorage.getItem("bill10type")
        }
        rawData = JSON.stringify(rawData)
        console.log(rawData);
        let formData = new FormData()
        formData.append('data', rawData)
        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            //  console.log(response.data)
            if (response.data && response.data.length > 0) {
                setDataSource(response.data);

                if (khrtype === "dreport") {

                    setPreviousAmt(response.data[0].
                        previousamt
                    );
                }

                setWait(false);
            }
            else {
                notifyerror(t("Khadyaadvreport.toast.noData"));

                setDataSource([]);
                setWait(false);
            }
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }


    const getudharidetails = () => {

    }

    function formatDate(inputDate) {
        // Ensure inputDate is in 'yyyy-mm-dd' format
        if (inputDate) {
            const parts = inputDate.split('-');
            if (parts.length !== 3) {
                return ''; // Invalid date format
            }

            // Convert month number to month name in English
            const months = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];

            const year = parts[0];
            const month = parseInt(parts[1]) - 1; // Subtract 1 because months are 0-based
            const day = parts[2];

            return `${day}-${months[month]}`;
            // -${year}`;

        }
    }

    function formatDatefull(inputDate) {
        // Ensure inputDate is in 'yyyy-mm-dd' format
        if (inputDate) {
            const parts = inputDate.split('-');
            if (parts.length !== 3) {
                return ''; // Invalid date format
            }

            // Convert month number to month name in English
            const months = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];

            const year = parts[0];
            const month = parseInt(parts[1]) - 1; // Subtract 1 because months are 0-based
            const day = parts[2];

            return `${day}-${months[month]} -${year}`;


        }
    }

    const showDetails = (kno, cname, lastadv, lastkhadya, lastdate) => {

        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "";

        landingphp = "getudharidetails2.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: kno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            billtype: localStorage.getItem("bill10type")
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)
        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {

            if (response.data && response.data.length > 0) {
                refprint.current.click();
                response.data && response.data.map((user, index) =>
                    setInput((prevInputSettings) => ({
                        ...prevInputSettings,
                        kno: kno,
                        kname: cname,
                        lastadv: user.lastadv,
                        lastkhadya: user.lastkhadya,
                        lastdate: lastdate
                    }))
                )
                setWait(false);
                getkhsalelatest(kno);
            }
            else {
                notifyerror(t("Khadyaadvreport.toast.noData"));

                setDataSource([]);
                setWait(false);
            }
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    const getkhsalelatest = (kno) => {

        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "";

        landingphp = "getkhsalelatest.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: kno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            billtype: localStorage.getItem("bill10type")
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)
        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {

            if (response.data && response.data.length > 0) {
                setDataSourcekh(response.data);
                setWait(false);
            }
            else {

                setDataSourcekh([]);
                setWait(false);
            }
            getadvlatest(kno);
        }).catch(err => {

            setWait(false);
        });
    }

    const getadvlatest = (kno) => {

        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        let landingphp = "";

        landingphp = "getadvlatest.php";

        let rawData = {
            date1: input.date1,
            date2: input.date2,
            kno: kno,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            billtype: localStorage.getItem("bill10type")
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)
        axios.post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {

            if (response.data && response.data.length > 0) {
                //   console.log(response.data);
                setDataSourceadv(response.data);
                setWait(false);
            }
            else {

                setDataSourceadv([]);
                setWait(false);
            }
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            // Make sure that the input is a string
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                // Create block
                var a = str.charCodeAt(i);
                // Bitwise XOR
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    useEffect(() => {
        getkhpartylist();
    }, [])

    async function getkhpartylist(flag) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhpartylist.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data.length > 0) {
                setPartydata(response.data);
                localStorage.setItem("dlist", JSON.stringify(response.data));

                getkhname();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (input.dno === "") {
            setInput(prevInput => ({
                ...prevInput,
                name: "",
            }))
        }
        else {

            let custlisttemp = partyData;
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({
                    ...prevInput,
                    name: ''
                }));
                const user = custlisttemp[i];
                if (user.kno === input.dno) {
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.name,
                    }));
                    break; // Exit the loop once the condition is met
                }
            }

        }
    }, [input.dno])

    const exportToExcel = () => {

        let wb = null;
        wb = XLSX.utils.table_to_book(document.getElementById('myTablebillyenebaki'), { sheet: "Sheet JS" });

        const ws = wb.Sheets["Sheet JS"];

        // Set column widths for specific columns (adjust the width values as needed)

        if (input.excelbank === "DCC Bank") {
            ws['!cols'] = [
                { wch: 20 }, { wch: 20 }, { wch: 20 }  // Only 3 columns
            ];
        } else {

            ws['!cols'] = [
                { wch: 20 },  // Width of first column
                { wch: 20 },
                { wch: 20 },  // Width for column 3 (account numbers)
                { wch: 8 },
                { wch: 40 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },  // Width of column 10
                { wch: 20 },
            ];
        }

        const range = XLSX.utils.decode_range(ws['!ref']);

        // Format column 10 (index 9) to replace '/' with '-'
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 9 })];  // Column 10 (index 9)
            if (cell && typeof cell.v === 'string') {
                cell.v = cell.v.replace(/\//g, '-');  // Replace all '/' with '-'
            }
        }

        // Prepend 'A' and ensure leading zeros are preserved for column 6 (index 5)
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 3 })];  // Column 6 (index 5)
            if (cell) {
                let cellValue = cell.v.toString();  // Ensure the value is treated as a string
                if (!cellValue.startsWith('A')) {  // Avoid adding 'A' multiple times
                    cell.v = `'A${cellValue}`;  // Add 'A' to the original value, force text format using single quote
                }
                cell.t = 's';  // Force the type to string
            }
        }

        // Ensure large numbers in column 3 (index 2) are treated as strings to avoid scientific notation
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 2 })];  // Column 3 (index 2)
            if (cell) {
                cell.v = cell.v.toString();  // Convert the number to a string
                cell.t = 's';  // Set the type to string
            }
        }

        // Format the header row for styling
        for (let C = 0; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (ws[cellAddress]) {
                ws[cellAddress].s = ws[cellAddress].s || {};
                ws[cellAddress].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "ADD8E6" }  // Light blue color
                };
                ws[cellAddress].s.font = { bold: true };
            }
        }

        // Save the file
        XLSX.writeFile(wb, 'Advance Report (' + input.date1 + " ते " + input.date2 + ").xlsx");
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refsaledetails}
                data-bs-target="#saledetails"
            >
            </button>

            <div className="modal fade" id="saledetails" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                ref={refsaledetailsclose}
                                aria-label="Close"
                            />
                        </div>

                        <div className="modal-body">
                            <h5 className="modaltitle" id="exampleModalLabel">
                                {t("Khadyaadvreport.modalSaleDetails.title", { khname: input.khname })}
                            </h5>

                            <div className="modalverti">
                                <span className="subheadsank">-------------</span>
                                <span className="labelkh">{t("Khadyaadvreport.modalSaleDetails.sectionTitle")}</span>

                                <table id="myTablebill" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.date")}</th>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.time")}</th>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.account")}</th>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.name")}</th>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.qty")}</th>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.rate")}</th>
                                            <th className="thsmall" scope="col">{t("Khadyaadvreport.modalSaleDetails.table.amount")}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {khsaledetails && khsaledetails.map((user, index) => (
                                            <tr key={index}>
                                                <td className="thsmallcust">{formatDate(user.date)}</td>
                                                <td className="thsmallcustlarge">{user.timee}</td>
                                                <td className="thsmallcustlarge">{user.kno}</td>
                                                <td className="thsmallcustlarge">{user.name}</td>
                                                <td className="thsmallcustlarge">{user.quin}</td>
                                                <td className="thsmallcustlarge">{user.rate}</td>
                                                <td className="thsmallcust">{parseFloat(user.amt).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                                        <td className="thsmallcust">{t("Khadyaadvreport.common.total")}</td>
                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>
                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>
                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>

                                        <td className="thsmallcustlarge">
                                            {khsaledetails.reduce((total, user) => total + parseFloat(user.quin), 0).toFixed(2)}
                                        </td>

                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>

                                        <td className="thsmallcustlarge">
                                            {khsaledetails.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprint}
                data-bs-target="#printinput"
            >
            </button>

            <div className="modal fade" id="printinput" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                ref={refprintclose}
                                aria-label="Close"
                            />
                        </div>

                        <div className="modal-body">
                            <h5 className="modaltitle" id="exampleModalLabel">
                                {t("Khadyaadvreport.modalCustomerDetails.title", {
                                    name: input.kname,
                                    kno: input.kno
                                })}
                            </h5>

                            <div className="modalverti">
                                <span className="subheadsank">-------------</span>

                                <span className="subheadsank">
                                    {t("Khadyaadvreport.modalCustomerDetails.lastBillLine", {
                                        date: formatDatefull(input.lastdate)
                                    })}
                                </span>

                                {localStorage.getItem("bill10type") === "1" ? (
                                    <div>
                                        <div className="modalhori">
                                            <div className="khadyabox">
                                                <img className="back" src={cash} alt="" />
                                                <div className="interbox">
                                                    <span className="labelkh">
                                                        {t("Khadyaadvreport.modalCustomerDetails.cards.asOfAdvance", {
                                                            date: formatDatefull(input.lastdate)
                                                        })}
                                                    </span>
                                                    <span className="redlable">₹ {input.lastadv}</span>
                                                </div>
                                            </div>

                                            <div className="khadyabox">
                                                <img className="back" src={khadya} alt="" />
                                                <div className="interbox">
                                                    <span className="labelkh">
                                                        {t("Khadyaadvreport.modalCustomerDetails.cards.asOfKhadya", {
                                                            date: formatDatefull(input.lastdate)
                                                        })}
                                                    </span>
                                                    <span className="redlable">₹ {input.lastkhadya}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="modalhori">
                                        <div className="khadyabox">
                                            <img className="back" src={cash} alt="" />
                                            <div className="interbox">
                                                <span className="labelkh">
                                                    {t("Khadyaadvreport.modalCustomerDetails.cards.asOfYenebaki", {
                                                        date: formatDatefull(input.lastdate)
                                                    })}
                                                </span>
                                                <span className="redlable">₹ {input.lastadv}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <span className="labelkh">
                                    {t("Khadyaadvreport.modalCustomerDetails.sections.advanceInfo")}
                                </span>

                                <table id="myTablebill" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.advance.date")}
                                            </th>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.advance.type")}
                                            </th>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.advance.amount")}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {DataSourceadv && DataSourceadv.map((user, index) => (
                                            <tr key={index}>
                                                <td className="thsmallcust">{formatDate(user.date)}</td>
                                                <td className="thsmallcustlarge">{user.type}</td>
                                                <td className="thsmallcust">{parseFloat(user.amt).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                                        <td className="thsmallcust">{t("Khadyaadvreport.common.total")}</td>
                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>
                                        <td className="thsmallcustlarge">
                                            {DataSourceadv.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </table>

                                <span className="labelkh">
                                    {t("Khadyaadvreport.modalCustomerDetails.sections.khadyaInfo")}
                                </span>

                                <table id="myTablebill" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.khadya.date")}
                                            </th>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.khadya.khadyaName")}
                                            </th>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.khadya.qty")}
                                            </th>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.khadya.rate")}
                                            </th>
                                            <th className="thsmall" scope="col">
                                                {t("Khadyaadvreport.modalCustomerDetails.tables.khadya.amount")}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {DataSourcekh && DataSourcekh.map((user, index) => (
                                            <tr key={index}>
                                                <td className="thsmallcust">{formatDate(user.date)}</td>
                                                <td className="thsmallcustlarge">{user.khname}</td>
                                                <td className="thsmallcust">{parseFloat(user.quin).toFixed(2)}</td>
                                                <td className="thsmallcust">{parseFloat(user.rate).toFixed(2)}</td>
                                                <td className="thsmallcust">{parseFloat(user.amt).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                                        <td className="thsmallcust">{t("Khadyaadvreport.common.total")}</td>
                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>
                                        <td className="thsmallcustlarge">
                                            {DataSourcekh.reduce((total, user) => total + parseFloat(user.quin), 0).toFixed(2)}
                                        </td>
                                        <td className="thsmallcustlarge">{t("Khadyaadvreport.common.dash")}</td>
                                        <td className="thsmallcust">
                                            {DataSourcekh.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="sanklanmain">
                <div className="firstrowsank">
                    <img onClick={props.visibility} className='back' src={back} alt="" />
                    <div className="colmain">
                        <div className="firstrow2">
                            <div className="rowbill">

                                {khrtype === "udhari" ? (
                                    <div className="mb-2">
                                        <span className="subheadsank">{t("Khadyaadvreport.filters.date")}</span>
                                        <input
                                            onKeyDown={(e) => handleEnterKey(e, 0)}
                                            ref={(ref) => (inputRefs.current[0] = ref)}
                                            type="date"
                                            className="form-control"
                                            autoComplete="off"
                                            id="date1"
                                            name="date1"
                                            value={input.date1}
                                            onChange={handleChange}
                                        />
                                    </div>
                                ) : khrtype === "stock" ? (
                                    ""
                                ) : (
                                    <>
                                        <div className="mb-2">
                                            <span className="subheadsank">{t("Khadyaadvreport.filters.date")}</span>
                                            <input
                                                onKeyDown={(e) => handleEnterKey(e, 0)}
                                                ref={(ref) => (inputRefs.current[0] = ref)}
                                                type="date"
                                                className="form-control"
                                                autoComplete="off"
                                                id="date1"
                                                name="date1"
                                                value={input.date1}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <span className="subheadbill">{t("Khadyaadvreport.filters.to")}</span>

                                        <div className="mb-2">
                                            <span className="subheadsank">{t("Khadyaadvreport.filters.date")}</span>
                                            <input
                                                onKeyDown={(e) => handleEnterKey(e, 1)}
                                                ref={(ref) => (inputRefs.current[1] = ref)}
                                                type="date"
                                                className="form-control"
                                                autoComplete="off"
                                                id="date2"
                                                name="date2"
                                                value={input.date2}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </>
                                )}

                                {khrtype === "datestock" ? (
                                    <div className="mb-2">
                                        <span className="subheadsank">{t("Khadyaadvreport.filters.khadyaName")}</span>
                                        <select
                                            onKeyDown={(e) => handleEnterKey(e, 2)}
                                            ref={(ref) => (inputRefs.current[2] = ref)}
                                            className="form-control inputfontkhlarge"
                                            autoComplete="off"
                                            id="khname"
                                            name="khname"
                                            value={input.khname}
                                            onChange={handleChange}
                                        >
                                            <option key={0} value={t("Khadyaadvreport.filters.selectKhadyaName")}>
                                                {t("Khadyaadvreport.filters.selectKhadyaName")}
                                            </option>

                                            {khnames
                                                ? khnames.map((opt, index) => (
                                                    <option key={index + 1} value={opt.khname}>
                                                        {opt.khname}
                                                    </option>
                                                ))
                                                : ""}
                                        </select>
                                    </div>
                                ) : (
                                    ""
                                )}

                                {khrtype === "dreport" ? (
                                    <div className="khreportrow">
                                        <div className="mb-2">
                                            <span className="subheadsank">{t("Khadyaadvreport.filters.dealerNo")}</span>
                                            <input
                                                onKeyDown={(e) => handleEnterKey(e, 0)}
                                                ref={(ref) => (inputRefs.current[0] = ref)}
                                                type="number"
                                                className="form-control"
                                                autoComplete="off"
                                                id="dno"
                                                name="dno"
                                                value={input.dno}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="mb-2 kdr">
                                            <span className="subheadsank">{t("Khadyaadvreport.filters.dealerName")}</span>
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                autoComplete="off"
                                                id="name"
                                                name="name"
                                                value={input.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}

                                <div className="mb-2">
                                    {wait ? (
                                        <button
                                            ref={(ref) => (inputRefs.current[4] = ref)}
                                            type="submit"
                                            id="show"
                                            className="btn btn-primary mx-1 sanksmall"
                                        >
                                            {t("Khadyaadvreport.common.loading")}
                                        </button>
                                    ) : (
                                        <button
                                            onClick={getkhpurreport}
                                            ref={(ref) => (inputRefs.current[4] = ref)}
                                            type="submit"
                                            id="show"
                                            className="btn btn-primary mx-1 sanksmall"
                                        >
                                            {t("Khadyaadvreport.buttons.viewReport")}
                                        </button>
                                    )}

                                    {khrtype === "adv" ? (
                                        <button
                                            onClick={exportToExcel}
                                            ref={(ref) => (inputRefs.current[4] = ref)}
                                            type="submit"
                                            id="print"
                                            className="btn btn-primary mx-1 sanksmall"
                                        >
                                            {t("Khadyaadvreport.buttons.excel")}
                                        </button>
                                    ) : (
                                        ""
                                    )}

                                    <button
                                        onClick={showprint}
                                        ref={(ref) => (inputRefs.current[4] = ref)}
                                        type="submit"
                                        id="print"
                                        className="btn btn-primary mx-1 sanksmall"
                                    >
                                        {t("Khadyaadvreport.buttons.print")}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="firstrow2">
                    <div class="table-containerbill">
                        <div className="buttonsreportsank">
                            {
                                khrtype === "khpur" || khrtype === "khsale" || khrtype === "adv" || khrtype === "udhari" ?
                                    <input
                                        type="text"
                                        className="form-control searchsank mx-3"
                                        id="searchsank"
                                        name="searchsank"
                                        placeholder={t("Khadyaadvreport.filters.searchAccountNo")}
                                        value={value}
                                        onChange={khrtype === "khpur" ? filteData : filteData}
                                        autoComplete="off"
                                    />

                                    :
                                    <input type="text" disabled className="form-control searchsank mx-3" id="searchsank" name="searchsank" placeholder={'--'} value={value} autoComplete='off' />

                            }
                            <div className="radio">
                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("khpur")}
                                        defaultChecked
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio1"
                                        value="option1"
                                    />
                                    <label className="form-check-label" htmlFor="radio1">
                                        {t("Khadyaadvreport.radios.khpur")}
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("khsale")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio2"
                                        value="option2"
                                    />
                                    <label className="form-check-label" htmlFor="radio2">
                                        {t("Khadyaadvreport.radios.khsale")}
                                    </label>
                                </div>
                            </div>

                            <div className="radio">
                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("stock")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio3"
                                        value="option3"
                                    />
                                    <label className="form-check-label" htmlFor="radio3">
                                        {t("Khadyaadvreport.radios.stock")}
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("dreport")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio4"
                                        value="option3"
                                    />
                                    <label className="form-check-label" htmlFor="radio4">
                                        {t("Khadyaadvreport.radios.dreport")}
                                    </label>
                                </div>
                            </div>

                            <div className="radio">
                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("datestock")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio5"
                                        value="option3"
                                    />
                                    <label className="form-check-label" htmlFor="radio5">
                                        {t("Khadyaadvreport.radios.datestock")}
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("adv")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio6"
                                        value="option3"
                                    />
                                    <label className="form-check-label" htmlFor="radio6">
                                        {t("Khadyaadvreport.radios.adv")}
                                    </label>
                                </div>
                            </div>

                            <div className="radio">
                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("udhari")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio7"
                                        value="option3"
                                    />
                                    <label className="form-check-label" htmlFor="radio7">
                                        {t("Khadyaadvreport.radios.udhari")}
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input
                                        onClick={(e) => handlertype("thakbaki")}
                                        className="form-check-input"
                                        type="radio"
                                        name="exampleRadios"
                                        id="radio8"
                                        value="option3"
                                    />
                                    <label className="form-check-label" htmlFor="radio8">
                                        {t("Khadyaadvreport.radios.thakbaki")}
                                    </label>
                                </div>
                            </div>

                        </div>
                        {
                            khrtype === "khpur" ?
                                <table id="myTablebillyenebaki" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="thsmallyenebaki2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.date")}
                                            </th>
                                            <th className="thsmallyenebaki2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.dealerAccount")}
                                            </th>
                                            <th className="thsmallyenebakimedium2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.dealerName")}
                                            </th>
                                            <th className="thsmallyenebakimedium2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.khadyaName")}
                                            </th>
                                            <th className="thsmallyenebaki2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.qty")}
                                            </th>
                                            <th className="thsmallyenebaki2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.rate")}
                                            </th>
                                            <th className="thsmallyenebaki2" scope="col">
                                                {t("Khadyaadvreport.tables.khpur.amount")}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {value.length > 0 ? tableFilter.map((user, index) =>
                                            <tr key={index}>
                                                <td className='thsmallyenebaki2'>{formatDate(user.date)}</td>
                                                <td className='thsmallyenebaki2'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                <td className='thsmallyenebakimedium2'>{user.name && user.name !== "" ? user.name : "-"}</td>
                                                <td className='thsmallyenebakimedium2'>{user.khname && user.khname !== "" ? user.khname : "-"}</td>
                                                <td className='thsmallyenebaki2'>{user.quin && user.quin !== "" ? parseFloat(user.quin) : 0}</td>
                                                <td className='thsmallyenebaki2'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                                <td className='thsmallyenebaki2'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                                            </tr>
                                        )
                                            :
                                            DataSource && DataSource.map((user, index) =>
                                                <tr key={index}>
                                                    <td className='thsmallyenebaki2'>{formatDate(user.date)}</td>
                                                    <td className='thsmallyenebaki2'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                    <td className='thsmallyenebakimedium2'>{user.name && user.name !== "" ? user.name : "-"}</td>
                                                    <td className='thsmallyenebakimedium2'>{user.khname && user.khname !== "" ? user.khname : "-"}</td>
                                                    <td className='thsmallyenebaki2'>{user.quin && user.quin !== "" ? parseFloat(user.quin) : 0}</td>
                                                    <td className='thsmallyenebaki2'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                                    <td className='thsmallyenebaki2'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>


                                    <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                       <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                        <td className='thsmallcustlarge'>-</td>
                                        <td className='thsmallcustlarge'>-</td>
                                        <td className='thsmallcustlarge'>-</td>
                                        <td className='thsmallcust'>
                                            {value.length > 0
                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.quin), 0).toFixed(2)
                                                : DataSource.reduce((total, user) => total + parseFloat(user.quin), 0).toFixed(2)}
                                        </td>
                                        <td className='thsmallcust'>-</td>
                                        <td className='thsmallcust'>
                                            {value.length > 0
                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)
                                                : DataSource.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </table>
                                :
                                khrtype === "khsale" ?
                                    <table id="myTablebillyenebaki" className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="thsmallyenebaki2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.date")}
                                                </th>
                                                <th className="thsmallyenebaki2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.time")}
                                                </th>
                                                <th className="thsmallyenebakimedium2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.accountName")}
                                                </th>
                                                <th className="thsmallyenebakimedium2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.khadyaName")}
                                                </th>
                                                <th className="thsmallyenebaki2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.qty")}
                                                </th>
                                                <th className="thsmallyenebaki2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.rate")}
                                                </th>
                                                <th className="thsmallyenebaki2" scope="col">
                                                    {t("Khadyaadvreport.tables.khsale.amount")}
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {value.length > 0 ? tableFilter.map((user, index) =>
                                                <tr key={index}>
                                                    <td className='thsmallyenebaki2'>{formatDate(user.date)}</td>
                                                    <td className='thsmallyenebaki2'>{user.timee}</td>
                                                    <td className='thsmallyenebakimedium2'>{user.kno + ": " + user.cname}</td>
                                                    <td className='thsmallyenebakimedium2'>{user.khname && user.khname !== "" ? user.khname : "-"}</td>
                                                    <td className='thsmallyenebaki2'>{user.quin && user.quin !== "" ? parseFloat(user.quin) : 0}</td>
                                                    <td className='thsmallyenebaki2'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                                    <td className='thsmallyenebaki2'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                                                </tr>
                                            )
                                                :
                                                DataSource && DataSource.map((user, index) =>
                                                    <tr key={index}>
                                                        <td className='thsmallyenebaki2'>{formatDate(user.date)}</td>
                                                        <td className='thsmallyenebaki2'>{user.timee}</td>
                                                        <td className='thsmallyenebakimedium2'>{user.kno + ": " + user.cname}</td>
                                                        <td className='thsmallyenebakimedium2'>{user.khname && user.khname !== "" ? user.khname : "-"}</td>
                                                        <td className='thsmallyenebaki2'>{user.quin && user.quin !== "" ? parseFloat(user.quin) : 0}</td>
                                                        <td className='thsmallyenebaki2'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                                        <td className='thsmallyenebaki2'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                        <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                           <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                            <td className='thsmallcustlarge'>-</td>
                                            <td className='thsmallcustlarge'>-</td>
                                            <td className='thsmallcustlarge'>-</td>
                                            <td className='thsmallcust'>
                                                {value.length > 0
                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.quin), 0).toFixed(2)
                                                    : DataSource.reduce((total, user) => total + parseFloat(user.quin), 0).toFixed(2)}
                                            </td>
                                            <td className='thsmallcust'>-</td>
                                            <td className='thsmallcust'>
                                                {value.length > 0
                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)
                                                    : DataSource.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    </table>
                                    :

                                    khrtype === "stock" ?
                                        localStorage.getItem("khdate") === "no" ?
                                            <table id="myTablebillyenebaki" className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.stockSimple.srNo")}
                                                        </th>
                                                        <th className="thsmallyenebakimedium2" scope="col">
                                                            {t("Khadyaadvreport.tables.stockSimple.khadyaName")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.stockSimple.totalPurchase")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.stockSimple.totalSale")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.stockSimple.stock")}
                                                        </th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    {value.length > 0 ? tableFilter.map((user, index) =>
                                                        <tr key={index}>
                                                            <td className='thsmallyenebaki2'>{index + 1}</td>
                                                            <td className='thsmallyenebakimedium2'>{user.khname}</td>
                                                            <td className='thsmallyenebaki2'>{user.total_purchase_qty && user.total_purchase_qty !== "" ? parseFloat(user.total_purchase_qty) : 0}</td>
                                                            <td className='thsmallyenebaki2'>{user.total_sale_qty && user.total_sale_qty !== "" ? parseFloat(user.total_sale_qty) : 0}</td>
                                                            <td className='thsmallyenebaki2'>{user.stock && user.stock !== "" ? parseFloat(user.stock) : 0}</td>
                                                        </tr>
                                                    )
                                                        :
                                                        DataSource && DataSource.map((user, index) =>
                                                            <tr key={index}>
                                                                <td className='thsmallyenebaki2'>{index + 1}</td>
                                                                <td className='thsmallyenebakimedium2'>{user.khname}</td>
                                                                <td className='thsmallyenebaki2'>{user.total_purchase_qty && user.total_purchase_qty !== "" ? parseFloat(user.total_purchase_qty) : 0}</td>
                                                                <td className='thsmallyenebaki2'>{user.total_sale_qty && user.total_sale_qty !== "" ? parseFloat(user.total_sale_qty) : 0}</td>
                                                                <td className='thsmallyenebaki2'>{user.stock && user.stock !== "" ? parseFloat(user.stock) : 0}</td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                                <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                   <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                    {/* <td className='thsmallcustlarge'>-</td> */}
                                                    <td className='thsmallcustlarge'>-</td>
                                                    <td className='thsmallcust'>
                                                        {value.length > 0
                                                            ? tableFilter.reduce((total, user) => total + parseFloat(user.total_purchase_qty), 0).toFixed(2)
                                                            : DataSource.reduce((total, user) => total + parseFloat(user.total_purchase_qty), 0).toFixed(2)}
                                                    </td>
                                                    <td className='thsmallcust'>
                                                        {value.length > 0
                                                            ? tableFilter.reduce((total, user) => total + parseFloat(user.total_sale_qty), 0).toFixed(2)
                                                            : DataSource.reduce((total, user) => total + parseFloat(user.total_sale_qty), 0).toFixed(2)}
                                                    </td>
                                                    <td className='thsmallcust'>
                                                        {value.length > 0
                                                            ? tableFilter.reduce((total, user) => total + parseFloat(user.stock), 0).toFixed(2)
                                                            : DataSource.reduce((total, user) => total + parseFloat(user.stock), 0).toFixed(2)}
                                                    </td>
                                                </tr>
                                            </table>
                                            : localStorage.getItem("khdate") === "yes" ?
                                                <table id="myTablebillyenebaki" className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.srNo")}
                                                            </th>
                                                            <th className="thsmallyenebakimedium2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.khadyaName")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.purchaseDate")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.purchaseRate")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.saleRate")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.purchaseStock")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.saleStock")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.transferStock")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.availableStock")}
                                                            </th>
                                                            <th className="thsmallyenebaki2" scope="col">
                                                                {t("Khadyaadvreport.tables.stockByDate.details")}
                                                            </th>
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        {value.length > 0 ? tableFilter.map((user, index) =>
                                                            <tr key={index}>
                                                                <td className='thsmallyenebaki2'>{index + 1}</td>
                                                                <td className='thsmallyenebakimedium2'>{user.khname}</td>
                                                                <td className='thsmallyenebaki2'>{user.date && user.date !== "" ? user.date : "-"}</td>
                                                                <td className='thsmallyenebaki2'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                                                <td className='thsmallyenebaki2'>{user.srate && user.srate !== "" ? parseFloat(user.srate) : 0}</td>
                                                            </tr>
                                                        )
                                                            :
                                                            DataSource && DataSource.map((user, index) =>
                                                                <tr key={index}>
                                                                    {
                                                                        user.current_stock !== "-" ?
                                                                            <>
                                                                                <td className='thsmallyenebaki2'>{index + 1}</td>
                                                                                <td className='thsmallyenebakimedium2'>{user.khname}</td>
                                                                                <td className='thsmallyenebaki2'>{user.date && user.date !== "" ? (user.date) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{user.srate && user.srate !== "" ? parseFloat(user.srate) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{user.quin && user.quin !== "" ? parseFloat(user.quin) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{user.sale_quin && user.sale_quin !== "" ? parseFloat(user.sale_quin) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{user.transfer && user.transfer !== "" ? parseFloat(user.transfer) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{user.current_stock && user.current_stock !== "" ? parseFloat(user.current_stock) : 0}</td>
                                                                                <td className='thsmallyenebaki2'>{<img onClick={e => handledetails(user.khname, user.date)} className='infokh' src={info} alt="" />}</td>
                                                                            </>
                                                                            : ''
                                                                    }
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                    <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                       <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                        <td className='thsmallcustlarge'>-</td>
                                                        <td className='thsmallcustlarge'>-</td>
                                                        <td className='thsmallcustlarge'>-</td>
                                                        <td className='thsmallcustlarge'>-</td>
                                                        <td className='thsmallcust'>
                                                            {value.length > 0
                                                                ? tableFilter.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.quin || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                                : DataSource.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.quin || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                            }

                                                        </td>
                                                        <td className='thsmallcust'>
                                                            {value.length > 0
                                                                ? tableFilter.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.sale_quin || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                                : DataSource.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.sale_quin || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                            }

                                                        </td>
                                                        <td className='thsmallcust'>
                                                            {value.length > 0
                                                                ? tableFilter.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.transfer || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                                : DataSource.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.transfer || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                            }

                                                        </td>
                                                        <td className='thsmallcust'>
                                                            {value.length > 0
                                                                ? tableFilter.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.current_stock || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                                : DataSource.reduce(
                                                                    (total, user) =>
                                                                        user.date !== '-' ? total + parseFloat(user.current_stock || 0) : total,
                                                                    0
                                                                ).toFixed(2)
                                                            }

                                                        </td>
                                                        <td className='thsmallcust'></td>
                                                    </tr>
                                                </table>
                                                :
                                                ''
                                        :

                                        khrtype === "datestock" ?
                                            <table id="myTablebillyenebaki" className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.dateStock.date")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.dateStock.openingStock")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.dateStock.purchase")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.dateStock.sale")}
                                                        </th>
                                                        <th className="thsmallyenebaki2" scope="col">
                                                            {t("Khadyaadvreport.tables.dateStock.closingStock")}
                                                        </th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    {value.length > 0 ? tableFilter.map((user, index) =>
                                                        <tr key={index}>
                                                            <td className='thsmallyenebaki2'>{user.date}</td>
                                                            <td className='thsmallyenebaki2'>{user.opening_stock}</td>
                                                            <td className='thsmallyenebaki2'>{user.purchase_qty}</td>
                                                            <td className='thsmallyenebaki2'>{user.sale_qty}</td>
                                                            <td className='thsmallyenebaki2'>{user.closing_stock}</td>

                                                        </tr>
                                                    )
                                                        :
                                                        DataSource && DataSource.map((user, index) =>
                                                            <tr key={index}>
                                                                <td className='thsmallyenebaki2'>{user.date}</td>
                                                                <td className='thsmallyenebaki2'>{user.opening_stock}</td>
                                                                <td className='thsmallyenebaki2'>{user.purchase_qty}</td>
                                                                <td className='thsmallyenebaki2'>{user.sale_qty}</td>
                                                                <td className='thsmallyenebaki2'>{user.closing_stock}</td>

                                                            </tr>
                                                        )
                                                    }
                                                </tbody>

                                            </table>

                                            :

                                            khrtype === "adv" ?
                                                <>
                                                    <table id="myTablebillyenebaki" className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="thsmallyenebaki2" scope="col">
                                                                    {t("Khadyaadvreport.tables.advanceReport.date")}
                                                                </th>
                                                                <th className="thsmallyenebakimedium2" scope="col">
                                                                    {t("Khadyaadvreport.tables.advanceReport.accountName")}
                                                                </th>
                                                                <th className="thsmallyenebakimedium2" scope="col">
                                                                    {t("Khadyaadvreport.tables.advanceReport.type")}
                                                                </th>
                                                                <th className="thsmallyenebakimedium2" scope="col">
                                                                    {t("Khadyaadvreport.tables.advanceReport.bankAccount")}
                                                                </th>
                                                                <th className="thsmallyenebaki2" scope="col">
                                                                    {t("Khadyaadvreport.tables.advanceReport.amount")}
                                                                </th>
                                                            </tr>

                                                        </thead>
                                                        <tbody>
                                                            {value.length > 0 ? tableFilter.map((user, index) =>
                                                                <tr key={index}>
                                                                    <td className='thsmallyenebaki2'>{formatDate(user.date)}</td>
                                                                    <td className='thsmallyenebakimedium2'>{user.kno + ": " + user.cname}</td>
                                                                    <td className='thsmallyenebakimedium2'>{user.type && user.type !== "" ? user.type : 0}</td>
                                                                    <td className='thsmallyenebakimedium2'>{user.accno && user.accno !== "" ? user.accno : 0}</td>
                                                                    <td className={user.type === "Debit" ? 'thsmallyenebaki2' : 'thsmallyenebakimedium2'}>{user.amt && user.amt !== "" ? parseFloat(user.amt).toFixed(2) : 0}</td>
                                                                </tr>
                                                            )
                                                                :
                                                                DataSource && DataSource.map((user, index) =>
                                                                    <tr key={index}>
                                                                        <td className='thsmallyenebaki2'>{formatDate(user.date)}</td>
                                                                        <td className='thsmallyenebakimedium2'>{user.kno + ": " + user.cname}</td>
                                                                        <td className='thsmallyenebakimedium2'>{user.type && user.type !== "" ? user.type : '-'}</td>
                                                                        <td className='thsmallyenebakimedium2'>{user.accno && user.accno !== "" ? user.accno : 0}</td>
                                                                        <td className={user.type === "Debit" ? 'thsmallyenebaki2' : 'thsmallyenebakimedium2'}>{user.amt && user.amt !== "" ? parseFloat(user.amt).toFixed(2) : 0}</td>
                                                                    </tr>
                                                                )
                                                            }

                                                        </tbody>

                                                        <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                           <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                            <td className='thsmallcustlarge'>-</td>
                                                            <td className='thsmallcust'>-</td>
                                                            <td className='thsmallcust'>-</td>
                                                            <td className='thsmallcust'>
                                                                {value.length > 0
                                                                    ?

                                                                    tableFilter.reduce((total, user) => {
                                                                        const amt = parseFloat(user.amt) || 0;
                                                                        if (user.type === 'Debit') return total + amt;
                                                                        if (user.type === 'Credit') return total - amt;
                                                                        return total;
                                                                    }, 0).toFixed(2)
                                                                    :


                                                                    DataSource.reduce((total, user) => {
                                                                        const amt = parseFloat(user.amt) || 0;
                                                                        if (user.type === 'Debit') return total + amt;
                                                                        if (user.type === 'Credit') return total - amt;
                                                                        return total;
                                                                    }, 0).toFixed(2)}


                                                            </td>
                                                        </tr>
                                                    </table>

                                                    <table hidden id="myTableexceldcc" className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className='thsmall' scope="col">Account Number</th>
                                                                <th className='thlarge' scope="col">Amount</th>
                                                                <th className='thlarge' scope="col">CrDr</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                DataSource && DataSource.map((user, index) =>
                                                                    <tr key={index}>
                                                                        <td className='thsmallbank'>{"A" + user.accno}</td>
                                                                        <td className='thsmallbank'>{parseFloat(user.amt).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}</td>
                                                                        <td className='thsmallbank'>{"Cr"}</td>
                                                                    </tr>
                                                                )
                                                            }

                                                        </tbody>
                                                    </table>
                                                </>
                                                :

                                                khrtype === "udhari" && localStorage.getItem("bill10type") === "1" ?

                                                    <table id="myTablebillyenebaki" className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="thsmallyenebaki" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.accountNo")}
                                                                </th>

                                                                <th className="thsmallyenebakimedium" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.accountName")}
                                                                </th>

                                                                <th className="thsmallyenebakimedium" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.lastBill")}
                                                                </th>

                                                                <th className="thsmallyenebaki" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.advanceDue")}
                                                                </th>

                                                                <th className="thsmallyenebaki" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.khadyaDue")}
                                                                </th>

                                                                <th className="thsmallyenebaki" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.ratibDue")}
                                                                </th>

                                                                <th
                                                                    className={localStorage.getItem("karj") === "On" ? "thsmallyenebaki" : "thsmallhide"}
                                                                    scope="col"
                                                                >
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.loanDue")}
                                                                </th>

                                                                <th
                                                                    className={localStorage.getItem("sanghk") === "On" ? "thsmallyenebaki" : "thsmallhide"}
                                                                    scope="col"
                                                                >
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.sanghDue")}
                                                                </th>

                                                                <th
                                                                    className={localStorage.getItem("retan") === "On" ? "thsmallyenebaki" : "thsmallhide"}
                                                                    scope="col"
                                                                >
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.retanDue")}
                                                                </th>

                                                                <th className="thsmallyenebaki" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.totalDue")}
                                                                </th>

                                                                <th className="thsmallyenebaki" scope="col">
                                                                    {t("Khadyaadvreport.tables.udhariBill10type1.details")}
                                                                </th>
                                                            </tr>

                                                        </thead>
                                                        <tbody>
                                                            {value.length > 0 ? tableFilter.map((user, index) =>
                                                                <tr key={index}>
                                                                    <td className='thsmallcustkhr'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                                    <td className='thsmallyenebakimedium'>{user.cname && user.cname !== "" ? user.cname : "-"}</td>
                                                                    <td className='thsmallyenebakimedium'>{user.date2 && user.date2 !== "" ? user.date2 : "-"}</td>
                                                                    <td className='thsmallyenebaki'>{user.newadv && user.newadv !== "" ? parseFloat(user.newadv).toFixed(2) : "-"}</td>
                                                                    <td className='thsmallyenebaki'>{user.newkhadya && user.newkhadya !== "" ? parseFloat(user.newkhadya).toFixed(2) : 0}</td>
                                                                    <td className='thsmallyenebaki'>{user.newratib && user.newratib !== "" ? parseFloat(user.newratib).toFixed(2) : 0}</td>
                                                                    <td className={localStorage.getItem("karj") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newkarj && user.newkarj !== "" ? parseFloat(user.newkarj).toFixed(2) : 0}</td>
                                                                    <td className={localStorage.getItem("sanghk") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newsangh && user.newsangh !== "" ? parseFloat(user.newsangh).toFixed(2) : 0}</td>
                                                                    <td className={localStorage.getItem("retan") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newretan && user.newretan !== "" ? parseFloat(user.newretan).toFixed(2) : 0}</td>
                                                                    <td className='thsmallyenebaki'>{user.newkhadya && user.newadv && user.newratib !== "" ? parseFloat(parseFloat(user.newkhadya) + parseFloat(user.newadv) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") == "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") == "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") == "On" ? user.newretan : 0)).toFixed(2) : 0}</td>
                                                                    <td className='thsmallyenebaki'><UilEye onClick={() => { showDetails(user.kno, user.cname, user.lastkhadya, user.lastadv, user.date2) }} className="ic" /></td>
                                                                </tr>
                                                            )
                                                                :
                                                                DataSource && DataSource.map((user, index) =>
                                                                    <tr key={index}>
                                                                        <td className='thsmallyenebaki'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                                        <td className='thsmallyenebakimedium'>{user.cname && user.cname !== "" ? user.cname : "-"}</td>
                                                                        <td className='thsmallyenebakimedium'>{user.date2 && user.date2 !== "" ? user.date2 : "-"}</td>
                                                                        <td className='thsmallyenebaki'>{user.newadv && user.newadv !== "" ? parseFloat(user.newadv).toFixed(2) : "-"}</td>
                                                                        <td className='thsmallyenebaki'>{user.newkhadya && user.newkhadya !== "" ? parseFloat(user.newkhadya).toFixed(2) : 0}</td>
                                                                        <td className='thsmallyenebaki'>{user.newratib && user.newratib !== "" ? parseFloat(user.newratib).toFixed(2) : 0}</td>
                                                                        <td className={localStorage.getItem("karj") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newkarj && user.newkarj !== "" ? parseFloat(user.newkarj).toFixed(2) : 0}</td>
                                                                        <td className={localStorage.getItem("sanghk") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newsangh && user.newsangh !== "" ? parseFloat(user.newsangh).toFixed(2) : 0}</td>
                                                                        <td className={localStorage.getItem("retan") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newretan && user.newretan !== "" ? parseFloat(user.newretan).toFixed(2) : 0}</td>
                                                                        <td className='thsmallyenebaki'>{user.newkhadya && user.newadv && user.newratib !== "" ? parseFloat(parseFloat(user.newkhadya) + parseFloat(user.newadv) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") == "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") == "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") == "On" ? user.newretan : 0)).toFixed(2) : 0}</td>
                                                                        <td className='thsmallyenebaki'><UilEye onClick={() => { showDetails(user.kno, user.cname, user.lastkhadya, user.lastadv, user.date2) }} className="ic" /></td>
                                                                    </tr>

                                                                )
                                                            }


                                                        </tbody>
                                                        <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                           <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                            <td className='thsmallcust'>-</td>
                                                            <td className='thsmallcust'>-</td>

                                                            <td className='thsmallcust'>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.newadv), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + parseFloat(user.newadv), 0).toFixed(2)}
                                                            </td>

                                                            <td className='thsmallcust'>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.newkhadya), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + parseFloat(user.newkhadya), 0).toFixed(2)}
                                                            </td>

                                                            <td className='thsmallcust'>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.newratib), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + parseFloat(user.newratib), 0).toFixed(2)}
                                                            </td>

                                                            <td className={localStorage.getItem("karj") == "On" ? 'thsmallcust' : 'thsmallhide'}>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.newkarj), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + parseFloat(user.newkarj), 0).toFixed(2)}
                                                            </td>

                                                            <td className={localStorage.getItem("sanghk") == "On" ? 'thsmallcust' : 'thsmallhide'}>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.newsangh), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + parseFloat(user.newsangh), 0).toFixed(2)}
                                                            </td>

                                                            <td className={localStorage.getItem("retan") == "On" ? 'thsmallcust' : 'thsmallhide'}>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.newretan), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + parseFloat(user.newretan), 0).toFixed(2)}
                                                            </td>


                                                            <td className='thsmallcust'>
                                                                {value.length > 0
                                                                    ? tableFilter.reduce((total, user) => total + (parseFloat(user.newadv) + parseFloat(user.newkhadya) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") === "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") === "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") === "On" ? user.newretan : 0)), 0).toFixed(2)
                                                                    : DataSource.reduce((total, user) => total + (parseFloat(user.newadv) + parseFloat(user.newkhadya) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") === "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") === "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") === "On" ? user.newretan : 0)), 0).toFixed(2)}
                                                            </td>
                                                            <td className='thsmallcust'>-</td>

                                                            {/* <td className='thsmallcust'>{DataSource.reduce((total, user) => total + parseFloat(parseFloat(user.newkhadya) +  parseFloat(user.newadv)).toFixed(2))}</td> */}

                                                        </tr>
                                                    </table>


                                                    :

                                                    khrtype === "udhari" && localStorage.getItem("bill10type") === "0" ?
                                                        <table id="myTablebill" className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th className='thsmall' scope="col">खाते क्र</th>
                                                                    <th className='thsmall' scope="col">खाते/नाव</th>
                                                                    <th className='thsmall' scope="col">शेवटचे बील</th>
                                                                    <th className='thsmall' scope="col">उधारी बाकी</th>
                                                                    <th className='thsmall' scope="col">डिटेल्स</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {value.length > 0 ? tableFilter.map((user, index) =>
                                                                    <tr key={index}>
                                                                        <td className='thsmallcust'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                                        <td className='thsmallcust'>{user.cname && user.cname !== "" ? user.cname : "-"}</td>
                                                                        <td className='thsmallcust'>{user.date2 && user.date2 !== "" ? user.date2 : "-"}</td>
                                                                        <td className='thsmallcust'>{user.tbaki && user.tbaki !== "" ? parseFloat(user.tbaki).toFixed(2) : "-"}</td>
                                                                        <td className='thsmallcust'><UilEye onClick={() => { showDetails(user.kno, user.cname, user.lastkhadya, user.lastadv, user.date2) }} className="ic" /></td>
                                                                    </tr>
                                                                )
                                                                    :
                                                                    DataSource && DataSource.map((user, index) =>
                                                                        <tr key={index}>
                                                                            <td className='thsmallcust'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                                            <td className='thsmallcust'>{user.cname && user.cname !== "" ? user.cname : "-"}</td>
                                                                            <td className='thsmallcust'>{user.date2 && user.date2 !== "" ? user.date2 : "-"}</td>
                                                                            <td className='thsmallcust'>{user.tbaki && user.tbaki !== "" ? parseFloat(user.tbaki).toFixed(2) : "-"}</td>
                                                                            <td className='thsmallcust'><UilEye onClick={() => { showDetails(user.kno, user.cname, user.lastkhadya, user.lastadv, user.date2) }} className="ic" /></td>
                                                                        </tr>

                                                                    )
                                                                }


                                                            </tbody>
                                                            <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                               <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                                <td className='thsmallcust'>-</td>
                                                                <td className='thsmallcust'>-</td>
                                                                <td className='thsmallcust'>
                                                                    {DataSource.reduce((total, user) => {
                                                                        const tbaki = parseFloat(user.tbaki);
                                                                        return isNaN(tbaki) ? total : total + tbaki;
                                                                    }, 0).toFixed(2)}
                                                                </td>
                                                                <td className='thsmallcust'>-</td>

                                                            </tr>
                                                        </table>
                                                        :

                                                        khrtype === "dreport" ?
                                                            <>
                                                                <table id="myTablebillyenebaki" className="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="thsmallyenebaki2" scope="col">
                                                                                {t("Khadyaadvreport.tables.dealerAccount.date")}
                                                                            </th>
                                                                            <th className="thsmallyenebakimedium2" scope="col">
                                                                                {t("Khadyaadvreport.tables.dealerAccount.particular")}
                                                                            </th>
                                                                            <th className="thsmallyenebaki2" scope="col">
                                                                                {t("Khadyaadvreport.tables.dealerAccount.debit")}
                                                                            </th>
                                                                            <th className="thsmallyenebaki2" scope="col">
                                                                                {t("Khadyaadvreport.tables.dealerAccount.credit")}
                                                                            </th>
                                                                            <th className="thsmallyenebaki2" scope="col">
                                                                                {t("Khadyaadvreport.tables.dealerAccount.balance")}
                                                                            </th>
                                                                        </tr>

                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            DataSource && DataSource.map((user, index) =>
                                                                                <tr key={index} className="thsmallcust" >
                                                                                    <td className="thsmallyenebaki2" >{formatDate(user.date)}</td>
                                                                                    <td className="thsmallyenebakimedium2">{user.particular}</td>
                                                                                    <td className="thsmallyenebaki2">{parseFloat(user.nave).toFixed(2)}</td>
                                                                                    <td className="thsmallyenebaki2">{parseFloat(user.jma).toFixed(2)}</td>
                                                                                    <td className="thsmallyenebaki2">{user.closing_balance && user.closing_balance !== "" ? parseFloat(user.closing_balance).toFixed(2) : "-"}</td>

                                                                                </tr>
                                                                            )
                                                                        }


                                                                    </tbody>
                                                                    <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                                       <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                                        <td className='thsmallcustlarge'>-</td>
                                                                        <td className='thsmallcust'>
                                                                            {parseFloat(
                                                                                DataSource.reduce((total, user) => {
                                                                                    return total + parseFloat(user.nave);
                                                                                }, 0)
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                        <td className='thsmallcust'>
                                                                            {parseFloat(
                                                                                DataSource.reduce((total, user) => {
                                                                                    return total + parseFloat(user.jma);
                                                                                }, 0)
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                        <td className='thsmallcustlarge'>-</td>
                                                                    </tr>
                                                                </table>
                                                            </>
                                                            :
                                                            khrtype === "thakbaki" ?

                                                                <table id="myTablebillyenebaki" className="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="thsmallyenebaki" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.accountNo")}
                                                                            </th>

                                                                            <th className="thsmallyenebakimedium" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.accountName")}
                                                                            </th>

                                                                            <th className="thsmallyenebakimedium" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.lastBill")}
                                                                            </th>

                                                                            <th className="thsmallyenebaki" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.advanceDue")}
                                                                            </th>

                                                                            <th className="thsmallyenebaki" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.khadyaDue")}
                                                                            </th>

                                                                            <th className="thsmallyenebaki" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.ratibDue")}
                                                                            </th>

                                                                            <th
                                                                                className={localStorage.getItem("karj") == "On" ? "thsmallyenebaki" : "thsmallhide"}
                                                                                scope="col"
                                                                            >
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.loanDue")}
                                                                            </th>

                                                                            <th
                                                                                className={localStorage.getItem("sanghk") == "On" ? "thsmallyenebaki" : "thsmallhide"}
                                                                                scope="col"
                                                                            >
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.sanghDue")}
                                                                            </th>

                                                                            <th
                                                                                className={localStorage.getItem("retan") == "On" ? "thsmallyenebaki" : "thsmallhide"}
                                                                                scope="col"
                                                                            >
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.retanDue")}
                                                                            </th>

                                                                            <th className="thsmallyenebaki" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.totalDue")}
                                                                            </th>

                                                                            <th className="thsmallyenebaki" scope="col">
                                                                                {t("Khadyaadvreport.tables.udhariBill10type1.details")}
                                                                            </th>
                                                                        </tr>

                                                                    </thead>
                                                                    <tbody>
                                                                        {value.length > 0 ? tableFilter.map((user, index) =>
                                                                            <tr key={index}>
                                                                                <td className='thsmallcustkhr'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                                                <td className='thsmallyenebakimedium'>{user.cname && user.cname !== "" ? user.cname : "-"}</td>
                                                                                <td className='thsmallyenebakimedium'>{user.date2 && user.date2 !== "" ? user.date2 : "-"}</td>
                                                                                <td className='thsmallyenebaki'>{user.newadv && user.newadv !== "" ? parseFloat(user.newadv).toFixed(2) : "-"}</td>
                                                                                <td className='thsmallyenebaki'>{user.newkhadya && user.newkhadya !== "" ? parseFloat(user.newkhadya).toFixed(2) : 0}</td>
                                                                                <td className='thsmallyenebaki'>{user.newratib && user.newratib !== "" ? parseFloat(user.newratib).toFixed(2) : 0}</td>
                                                                                <td className={localStorage.getItem("karj") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newkarj && user.newkarj !== "" ? parseFloat(user.newkarj).toFixed(2) : 0}</td>
                                                                                <td className={localStorage.getItem("sanghk") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newsangh && user.newsangh !== "" ? parseFloat(user.newsangh).toFixed(2) : 0}</td>
                                                                                <td className={localStorage.getItem("retan") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newretan && user.newretan !== "" ? parseFloat(user.newretan).toFixed(2) : 0}</td>
                                                                                <td className='thsmallyenebaki'>{user.newkhadya && user.newadv && user.newratib !== "" ? parseFloat(parseFloat(user.newkhadya) + parseFloat(user.newadv) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") == "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") == "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") == "On" ? user.newretan : 0)).toFixed(2) : 0}</td>
                                                                                <td className='thsmallyenebaki'><UilEye onClick={() => { showDetails(user.kno, user.cname, user.lastkhadya, user.lastadv, user.date2) }} className="ic" /></td>
                                                                            </tr>
                                                                        )
                                                                            :
                                                                            DataSource && DataSource.map((user, index) =>
                                                                                <tr key={index}>
                                                                                    <td className='thsmallyenebaki'>{user.kno && user.kno !== "" ? user.kno : "-"}</td>
                                                                                    <td className='thsmallyenebakimedium'>{user.cname && user.cname !== "" ? user.cname : "-"}</td>
                                                                                    <td className='thsmallyenebakimedium'>{user.date2 && user.date2 !== "" ? user.date2 : "-"}</td>
                                                                                    <td className='thsmallyenebaki'>{user.newadv && user.newadv !== "" ? parseFloat(user.newadv).toFixed(2) : "-"}</td>
                                                                                    <td className='thsmallyenebaki'>{user.newkhadya && user.newkhadya !== "" ? parseFloat(user.newkhadya).toFixed(2) : 0}</td>
                                                                                    <td className='thsmallyenebaki'>{user.newratib && user.newratib !== "" ? parseFloat(user.newratib).toFixed(2) : 0}</td>
                                                                                    <td className={localStorage.getItem("karj") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newkarj && user.newkarj !== "" ? parseFloat(user.newkarj).toFixed(2) : 0}</td>
                                                                                    <td className={localStorage.getItem("sanghk") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newsangh && user.newsangh !== "" ? parseFloat(user.newsangh).toFixed(2) : 0}</td>
                                                                                    <td className={localStorage.getItem("retan") == "On" ? 'thsmallyenebaki' : 'thsmallhide'}>{user.newretan && user.newretan !== "" ? parseFloat(user.newretan).toFixed(2) : 0}</td>
                                                                                    <td className='thsmallyenebaki'>{user.newkhadya && user.newadv && user.newratib !== "" ? parseFloat(parseFloat(user.newkhadya) + parseFloat(user.newadv) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") == "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") == "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") == "On" ? user.newretan : 0)).toFixed(2) : 0}</td>
                                                                                    <td className='thsmallyenebaki'><UilEye onClick={() => { showDetails(user.kno, user.cname, user.lastkhadya, user.lastadv, user.date2) }} className="ic" /></td>
                                                                                </tr>

                                                                            )
                                                                        }


                                                                    </tbody>
                                                                    <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                                                       <td className='thsmallcust'>{t("Khadyaadvreport.common.total")}</td>
                                                                        <td className='thsmallcust'>-</td>
                                                                        <td className='thsmallcust'>-</td>

                                                                        <td className='thsmallcust'>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.newadv), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + parseFloat(user.newadv), 0).toFixed(2)}
                                                                        </td>

                                                                        <td className='thsmallcust'>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.newkhadya), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + parseFloat(user.newkhadya), 0).toFixed(2)}
                                                                        </td>

                                                                        <td className='thsmallcust'>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.newratib), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + parseFloat(user.newratib), 0).toFixed(2)}
                                                                        </td>

                                                                        <td className={localStorage.getItem("karj") == "On" ? 'thsmallcust' : 'thsmallhide'}>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.newkarj), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + parseFloat(user.newkarj), 0).toFixed(2)}
                                                                        </td>

                                                                        <td className={localStorage.getItem("sanghk") == "On" ? 'thsmallcust' : 'thsmallhide'}>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.newsangh), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + parseFloat(user.newsangh), 0).toFixed(2)}
                                                                        </td>

                                                                        <td className={localStorage.getItem("retan") == "On" ? 'thsmallcust' : 'thsmallhide'}>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + parseFloat(user.newretan), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + parseFloat(user.newretan), 0).toFixed(2)}
                                                                        </td>


                                                                        <td className='thsmallcust'>
                                                                            {value.length > 0
                                                                                ? tableFilter.reduce((total, user) => total + (parseFloat(user.newadv) + parseFloat(user.newkhadya) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") === "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") === "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") === "On" ? user.newretan : 0)), 0).toFixed(2)
                                                                                : DataSource.reduce((total, user) => total + (parseFloat(user.newadv) + parseFloat(user.newkhadya) + parseFloat(user.newratib) + parseFloat(localStorage.getItem("karj") === "On" ? user.newkarj : 0) + parseFloat(localStorage.getItem("sanghk") === "On" ? user.newsangh : 0) + parseFloat(localStorage.getItem("retan") === "On" ? user.newretan : 0)), 0).toFixed(2)}
                                                                        </td>
                                                                        <td className='thsmallcust'>-</td>

                                                                        {/* <td className='thsmallcust'>{DataSource.reduce((total, user) => total + parseFloat(parseFloat(user.newkhadya) +  parseFloat(user.newadv)).toFixed(2))}</td> */}

                                                                    </tr>
                                                                </table>


                                                                : ''

                        }
                    </div>

                </div>

            </div>

        </>
    )
}

export default Khadyaadvreport
